import type { GridAudioSoundPlayer, PresentationTaskRunner } from "@slot/presentation";
import type { AudioService } from "../ports/AudioService";

/**
 * The grid's sound player over the shell's audio service (decision 46; each title wrote it until then): the land
 * reactions and the mechanics play sound ids through it. A delayed play waits on engine time, so a land stagger pauses
 * and speed-scales with the presentation like every other land cue.
 */
export function createGridAudio(input: { audioService: AudioService; runner: PresentationTaskRunner }): GridAudioSoundPlayer {
  const audio = input.audioService.presentation;
  return {
    playSoundId: (soundId, opts) => {
      audio.playSoundId?.(soundId, opts);
    },
    playSoundIdDelayed: (soundId, delaySeconds, opts) => {
      void input.runner.sleep(Math.max(0, delaySeconds)).then(() => {
        audio.playSoundId?.(soundId, opts);
      });
    },
    startLoop: (soundId) => {
      audio.startSfxLoop?.(soundId);
    },
    stopLoop: (soundId) => {
      audio.stopSfxLoop?.(soundId);
    },
    setLoopGainScale: (soundId, scale) => {
      audio.setSfxLoopGainScale?.(soundId, scale);
    },
  };
}
